
import photo from '@/assets/img/doctor0.jpg'
import anger from '@/assets/icons/anger.png'
import Rater from 'vux/src/components/rater/index.vue'

import starValueNumber from './starValueNumber.vue'
export default {
props: ['data'],
data () {
return {
photo,
anger
}
},
components: {

starValueNumber
},
methods:{
},
methods:{
}
}



// WEBPACK FOOTER //
// ./src/components/clinic/evaluate.vue